// extracted by mini-css-extract-plugin
module.exports = {"wizard":"DateOfBirth_wizard__3W_d8"};